import styled from 'styled-components';

import { Container } from '@/components/flexboxgrid';

import Header from '@/components/ui/header/secondary-header';

import PurpleCirclesSVG from '../../../public/assets/images/privacy-policy/purple-circles.svg';
import OrangeCirclesSVG from '../../../public/assets/images/privacy-policy/orange-circles.svg';

const LeftImage = styled(PurpleCirclesSVG)`
  position: absolute;
  bottom: 0;
  left: -550px;
`;

const RightImage = styled(OrangeCirclesSVG)`
  position: absolute;
  top: 100px;
  right: -550px;
`;

const SimpleContent = styled.div`
  font-family: ${(props) => props.theme.fonts.grosa};
  color: ${(props) => props.theme.colors.brown};
  padding-top: 35px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    padding-top: 20px;
  }

  ${Container} {
    position: relative;
    max-width: 864px;
    padding-bottom: 130px;

    @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
      padding-bottom: 80px;
    }
  }
`;

export default function Content({ children, title }) {
  return (
    <>
      <Header>
        <Container>
          <h1>{title}</h1>
        </Container>
      </Header>

      <SimpleContent>
        <Container>
          <LeftImage />
          <RightImage />
          {children}
        </Container>
      </SimpleContent>
    </>
  );
}
